import React from 'react';
import { Modal } from './Modal';
import Button from './Button';
import { AlertTriangle, Info, type LucideIcon } from 'lucide-react';

type ButtonVariant = 'primary' | 'secondary' | 'success' | 'danger' | 'warning';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmButtonVariant?: ButtonVariant;
  icon?: LucideIcon;
  isLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmButtonVariant = 'primary',
  icon: IconComponent,
  isLoading = false,
}) => {
  const defaultIcon = confirmButtonVariant === 'danger' ? AlertTriangle : Info;
  const CurrentIcon = IconComponent || defaultIcon;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <div className="p-4 text-center">
        <div className="flex justify-center mb-4">
          <CurrentIcon className={`w-12 h-12 ${confirmButtonVariant === 'danger' ? 'text-red-500' : confirmButtonVariant === 'warning' ? 'text-orange-500' : 'text-primary-500'}`} />
        </div>
        <p className="text-gray-700 mb-6">{message}</p>
        <div className="flex justify-center space-x-4">
          <Button variant="secondary" onClick={onClose} disabled={isLoading}>
            {cancelText}
          </Button>
          <Button variant={confirmButtonVariant} onClick={onConfirm} loading={isLoading}>
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
